import { Action } from '@ngrx/store';
import { UserDetailedInterface, UserInterface } from 'app/core/user/models';

import { ErgoTeamMemberInterface } from '../../models/ergo-team-member.model';

import { UserActionType } from './user-action-type.enum';

export class LoadSingleUser implements Action {
  public readonly type: UserActionType = UserActionType.LoadSingleUser;

  constructor(public readonly payload: number) { }
}

export class LoadSingleUserCompleted implements Action {
  public readonly type: UserActionType = UserActionType.LoadSingleUserCompleted;

  constructor(public readonly payload: UserInterface) { }
}

export class LoadSingleUserFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadSingleUserFailed;

  constructor(public readonly payload: UserInterface) { }
}

export class LoadUserErgoTeam implements Action {
  public readonly type: UserActionType = UserActionType.LoadUserErgoTeam;

  constructor(public readonly payload: UserInterface) { }
}

export class LoadUserErgoTeamCompleted implements Action {
  public readonly type: UserActionType = UserActionType.LoadUserErgoTeamCompleted;

  constructor(public readonly payload: ErgoTeamMemberInterface[]) { }
}

export class LoadUserErgoTeamFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadUserErgoTeamFailed;

  constructor(public readonly payload: string) { }
}

export class LoadUsers implements Action {
  public readonly type: UserActionType = UserActionType.LoadUsers;
  public readonly payload: any = undefined;
}

export class LoadUsersCompleted implements Action {
  public readonly type: UserActionType = UserActionType.LoadUsersCompleted;

  constructor(public readonly payload: UserInterface[]) { }
}

export class LoadUsersFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadUsersFailed;

  constructor(public readonly payload: string) { }
}

export class LoadDetailedUsers implements Action {
  public readonly type: UserActionType = UserActionType.LoadDetailedUsers;
  public readonly payload: any = undefined;
}

export class LoadDetailedUsersCompleted implements Action {
  public readonly type: UserActionType = UserActionType.LoadDetailedUsersCompleted;

  constructor(public readonly payload: UserDetailedInterface[]) { }
}

export class LoadDetailedUsersFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadDetailedUsersFailed;

  constructor(public readonly payload: string) { }
}

export class LoadAdminUsers implements Action {
  public readonly type: UserActionType = UserActionType.LoadAdminUsers;
  public readonly payload: any = undefined;
}

export class LoadAdminUsersCompleted implements Action {
  public readonly type: UserActionType = UserActionType.LoadAdminUsersCompleted;

  constructor(public readonly payload: UserInterface[]) { }
}

export class LoadAdminUsersFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadAdminUsersFailed;

  constructor(public readonly payload: string) { }
}

export class LoadUserFromLoggedInUser implements Action {
  public readonly type: UserActionType = UserActionType.LoadUserFromLoggedInUser;
  public readonly payload: any = undefined;
}

export class LoadUserFromLoggedInUserFailed implements Action {
  public readonly type: UserActionType = UserActionType.LoadUserFromLoggedInUserFailed;

  constructor(public readonly payload: string) { }
}
